export const LIVE_COPY = {
  toastTitle: '有新訊息',
  toastDetail: '收件匣有新訊息。',
  view: '查看',
  notificationTitle: '回覆助手：有新訊息',
  notificationBody: '收件匣有新訊息，按一下查看。',
  disconnected: '即時更新已中斷，正在重新連線…',
} as const
